var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h5-login',{staticClass:"login",attrs:{"base-url":_vm.baseUrl,"config-data":_vm.configData,"callback_uri":_vm.callback_uri,"client_game_app_id":_vm.client_game_app_id},on:{"loginSuccess":_vm.loginSuccess,"close":_vm.close}})
}
var staticRenderFns = []

export { render, staticRenderFns }